import { render, staticRenderFns } from "./SpecificBodyPartsForm.vue?vue&type=template&id=ac36599c"
import script from "./SpecificBodyPartsForm.vue?vue&type=script&lang=js"
export * from "./SpecificBodyPartsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports